import {Button} from 'quickstart/components/controls'
import {Modal, Stack} from 'quickstart/components/layout'
import {useMarkdownMaybe} from 'quickstart/components/layout/FormShell/useMarkdownMaybe'
import type {ReactNode} from 'react'
import {logger} from 'tizra'
import {SIGN_IN, SIGN_IN_TITLE} from './common'
import {ssoLogin} from './ssoLogin'

const log = logger('SsoSignIn')

export interface SsoSignInProps {
  authAgent: 'custom' | 'sso'
  message?: ReactNode
  modal?: boolean
  successUrl?: string
}

export const SsoSignIn = ({
  authAgent,
  message: rawMessage,
  modal,
  successUrl,
}: SsoSignInProps) => {
  let ssoButton = (
    <Button onClick={() => ssoLogin(authAgent, successUrl)}>{SIGN_IN}</Button>
  )

  const message = useMarkdownMaybe(rawMessage)
  if (message) {
    ssoButton = (
      <Stack spacing="xl">
        {message}
        {ssoButton}
      </Stack>
    )
  }

  if (modal) {
    ssoButton = (
      <>
        <Modal.Title>{SIGN_IN_TITLE}</Modal.Title>
        <Modal.Content>{ssoButton}</Modal.Content>
      </>
    )
  }
  return ssoButton
}
